import React, { FC, useState } from "react";
import FilterMenuView from "./FilterMenuView";
import { ClassesFilter, ClassesFilterItem } from "src/Models/ClassesFilter";
import Select from "react-select";
import Option from "../../../Components/MultipleSelect";
import FilterModal, { LocalFilter } from "./FilterModal";
import { CurrentFilter, CurrentPagination } from "src/Models/CurrentFilter";

interface FilterViewProps {
  filters: ClassesFilter | undefined;
  onAddFilter: (type: string, value: string | string[]) => void;
  setCurrentFilter: React.Dispatch<React.SetStateAction<CurrentFilter>>;
  setCurrentPagination: React.Dispatch<React.SetStateAction<CurrentPagination>>;
  currentFilter: CurrentFilter;
}

const FilterView: FC<FilterViewProps> = ({
  filters,
  onAddFilter,
  setCurrentFilter,
  currentFilter,
  setCurrentPagination,
}) => {
  const multi = filters?.genre_id?.values.map((course) => ({
    label: course.name,
    value: course.id,
  }));

  const multiLength = filters?.length?.values.map((length) => ({
    label: length,
    value: length,
  }));

  const modality = filters?.modality?.values.map((item) => {
    return {
      value: item,
      label: item,
    };
  });

  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const root = document.getElementById("root");
  const mediaUrl = root?.getAttribute("data-static-content");

  return (
    <div className="filter_view">
      <div className="wrapper">
        {filters?.genre_category_id?.values.map((item) => (
          <div key={item.id}>
            <FilterMenuView
              icon={item.icon}
              icon_selected={item.icon_selected}
              title={item.name}
              onClick={(type, id) => {
                if (
                  currentFilter.genre_category_id?.includes(String(item.id))
                ) {
                  onAddFilter(type, []);
                } else {
                  onAddFilter(type, [String(id)]);
                }
              }}
              id={String(item.id)}
              active={
                currentFilter.genre_category_id?.includes(String(item.id)) ||
                false
              }
              type="genre_category_id"
            />
          </div>
        ))}

        {filters?.genre_feature_id?.values.map((item) => ( item.name !== 'Most Popular' ? // TODO: Remove this button on the API
                <div key={item.id} className="feature">
                  <FilterMenuView
                    icon={item.icon}
                    icon_selected={item.icon_selected}
                    title={item.name}
                    onClick={(type, id) => {
                      if (
                        currentFilter.genre_feature_id?.includes(String(item.id))
                      ) {
                        onAddFilter(type, []);
                      } else {
                        onAddFilter(type, [String(id)]);
                      }
                    }}
                    id={String(item.id)}
                    active={
                      currentFilter.genre_feature_id?.includes(String(item.id)) ||
                      false
                    }
                    type="genre_feature_id"
                  />
                </div> : ''
              ))}
      </div>
      <div className="container_dropdown">
        <div className="wrapper">
          <Select
            options={multi}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            className="dropdown dropdown-large"
            components={{
              Option,
            }}
            onChange={(e) => {
              const list = e.map((item) => item.value);
              onAddFilter("genre_id", list);
            }}
            placeholder="Search courses by name"
            value={multi?.filter((item) =>
              currentFilter.genre_id?.includes(item.value)
            )}
          />
          <Select
            options={modality}
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            isMulti
            components={{
              Option,
            }}
            className="dropdown"
            onChange={(e) => {
              const list = e.map((item) => item.value);
              onAddFilter("modality", list);
            }}
            placeholder="Where"
            isSearchable={false}
            value={modality?.filter((item) =>
              currentFilter.modality?.includes(item.value)
            )}
          />
          <Select
            options={multiLength}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
            className="dropdown"
            components={{
              Option,
            }}
            onChange={(e) => {
              const list = e.map((item) => item.value);
              onAddFilter("length", list);
            }}
            placeholder="Length"
            isSearchable={false}
            value={multiLength?.filter((item) =>
              currentFilter.length?.includes(item.value)
            )}
          />
          <button onClick={() => setModalOpen(true)}>
            <img
              src={`${mediaUrl}More.svg`}
              className="more_icon"
              alt="close"
            />
            More Filters
          </button>
          <button
            onClick={() => {
              setCurrentFilter({
                length: [],
                modality: [],
                genre_id: [],
                sort_by: "date",
                days: [],
                time_of_day: [],
                price: [],
                genre_category_id: [],
                genre_feature_id: [],
              });
              setCurrentPagination({ page: "1" });
            }}
          >
            <img
              src={`${mediaUrl}Close.svg`}
              className="clear_icon"
              alt="close"
            />
            Clear Filters
          </button>
          <FilterModal
            modalIsOpen={isModalOpen}
            closeModal={() => {
              setModalOpen(false);
            }}
            onAddFilter={(local: LocalFilter) => {
              setCurrentFilter({
                ...currentFilter,
                days: local.days,
                price: local.price,
                time_of_day: local.time_of_day,
                genre_feature_id: local.genre_feature_id,
                genre_category_id:
                  local.genre_feature_id.length > 0
                    ? []
                    : currentFilter.genre_category_id,
                genre_id:
                  local.genre_feature_id.length > 0
                    ? []
                    : currentFilter.genre_id,
              });
              setCurrentPagination({ page: "1" });
            }}
            days={filters?.days?.values || []}
            time_of_day={filters?.time_of_day?.values || []}
            price={filters?.price?.values || []}
            genre_feature_id={filters?.genre_feature_id}
            currentFilter={currentFilter}
          />
        </div>
      </div>

      <div className="selected_filters">
        <div className="wrapper">
          {Object.keys(currentFilter).map((filterKey) => {
            const currentValue =
              currentFilter[filterKey as keyof CurrentFilter];
            if (filterKey === "sort_by" || filterKey === "page") {
              return null;
            }

            type FilterType = {
              genre_id: [ClassesFilterItem] | undefined;
              genre_category_id: [ClassesFilterItem] | undefined;
              genre_feature_id: [ClassesFilterItem] | undefined;
            };
            const list: FilterType = {
              genre_id: undefined,
              genre_category_id: undefined,
              genre_feature_id: undefined,
            };

            const types = ["genre_id", "genre_category_id", "genre_feature_id"];

            list.genre_id = filters?.genre_id.values;
            list.genre_category_id = filters?.genre_category_id.values;
            list.genre_feature_id = filters?.genre_feature_id.values;
            return (currentValue as string[]).map((value) => (
              <div className="tag" key={value}>
                <>
                  {types.indexOf(filterKey) === -1
                    ? filterKey === "price"
                      ? Array.from(Array(Number(value)).keys()).map(() => "$")
                      : value
                    : `${filterKey === "genre_category_id" ? "All" : ""}  ${
                        list[filterKey as keyof FilterType]?.find(
                          (item) => String(item.id) === String(value)
                        )?.name || ""
                      }`}{" "}
                  <span
                    onClick={() => {
                      onAddFilter(
                        filterKey,
                        (currentValue as string[]).filter(
                          (current) => current !== value
                        )
                      );
                    }}
                    className="remove tag"
                  >
                    X
                  </span>
                </>
              </div>
            ));
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterView;
